var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeshboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "48 291 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 300.444h7.555V291H48v9.444ZM48 308h7.555v-5.667H48V308Zm9.444 0H65v-9.444h-7.556V308Zm0-17v5.667H65V291h-7.556Z",
    fill: "#505050",
    fillRule: "evenodd",
    "data-name": "Icon material-dashboard"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeshboardIcon);
export default __webpack_public_path__ + "static/media/deshboardIcon.e553ca770d358343487b6d37188f317f.svg";
export { ForwardRef as ReactComponent };